import Home from '@/views/pages/Home.vue'

const router = {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
        title: 'Home'
    }
  };

export default router
